import React, { useEffect } from "react";
import gsap from "gsap";
import lightHouseImage from "../img/envision/valuefirst/cards/valuefirst1.png";

const ValueFirstDatasection = () => {
  useEffect(() => {
    // Handle scroll event
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const leftContainer = document.querySelector(".left-container");
      const rightContainer = document.querySelector(".right-container");

      // Animate left container from left
      gsap.to(leftContainer, {
        x: scrollPosition > 100 ? 0 : -200, // Move left container into view
        opacity: scrollPosition > 100 ? 1 : 0, // Fade in the left container
        duration: 1,
      });

      // Animate right container from right
      gsap.to(rightContainer, {
        x: scrollPosition > 100 ? 0 : 200, // Move right container into view
        opacity: scrollPosition > 100 ? 1 : 0, // Fade in the right container
        duration: 1,
      });
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <style>
        {`
          .span6 {
            width: 48%;
            box-sizing: border-box;
            padding: 10px;
          }

          .details {
            padding: 20px;
          }

          .details h2 {
            margin-bottom: 20px;
            font-size: 2rem;
            font-weight: bold;
          }

          .details p {
            font-size: 1rem;
            color: #333;
          }

          .light-house-image {
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .light-house-image img {
            max-width: 100%;
            height: auto;
          }

          .box {
            width: 100%;
            height: 100px;
          
          }

          /* Add classes for GSAP animation */
          .left-container,
          .right-container {
            position: relative;
            opacity: 0;
            transform: translateX(-200px); /* Initially off-screen */
          }

          /* Responsive adjustments */
          @media (max-width: 768px) {
            .span6 {
              width: 100%;
            }
          }
        `}
      </style>

      <section className="lighthouse-section" style={{ marginTop: '50px' }}>
        <div className="lighthouse-section-container">
          <div className="container">
            <div className="row">
              <div
                className="span6 left-container aos-init aos-animate"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="800"
                data-aos-easing="ease-in-sine"
              >
                <h2 className="mb-4">
                  <span style={{ color: "rgb(18 128 160)" }}>
                    The lighthouse always
                  </span>{" "}
                  guides us home!
                </h2>
                <p style={{ textAlign: "justify" }}>
                  <span>
                    Just like a lighthouse that guides every sailor in the dark, our
                    ValuesFIRST give us direction and show us how to drive differentiation
                    in all our endeavors. It helps us reinvent with time and ensure that
                    our customers succeed. Our values also act as our anchors in troubled
                    waters. No matter how tough a decision is, it is always backed with our
                    ethics.
                  </span>
                </p>
                <p style={{ textAlign: "justify" }}>
                  <span>
                    This is how we navigate the business landscapes seamlessly. This is
                    how we <strong>Design Tomorrow, Together.</strong>
                  </span>
                </p>
              </div>

              <div
                className="span6 right-container aos-init aos-animate"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="800"
                data-aos-easing="ease-in-sine"
              >
                <img
                  className="lazyloaded"
                  alt="light-house-img"
                  loading="lazy"
                  style={{ maxWidth: "100%", height: "auto" }}
                  src={lightHouseImage}
                  height="659"
                  width="960"
                />

                <div className="box"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ValueFirstDatasection;
